/**
 * Set Vue i18n multi language
 *
 * @author minkyoung.park@emcast.com
 */

// Define Components/Api/filter/Plugin
import Vue from 'vue'
import axios from 'axios'
import i18nApi from '@/api/i18nApi.js'
import Moment from 'moment' 
import store from '@/store/index.js' 
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

export const i18n = new VueI18n({})

function setParams() {    
    let params = {
        brandCode: localStorage.getItem('brandCode')
    }
    return params
}

// Get Default Language
function getDefaultLanguage(systemlanguageSet, selectlang) {

    return new Promise((resolve, reject) => {
        // 수동으로 언어 변경할때
        if (selectlang) {
            // console.log('Manual Change')            
            resolve(_.find(systemlanguageSet, (lang) => {return lang.code === selectlang}))
        }else {
            // 이미 설정된 언어 정보가 있을 경우
            let setedLanguageInfo = JSON.parse(localStorage.getItem('languageInfo'))
            if (setedLanguageInfo) {
                // console.log('Seted Language');
                resolve(_.find(systemlanguageSet, (lang) => {return lang.code === setedLanguageInfo.code}))
            }else {
                // 처음 접근 할 경우
                let params = setParams()
                i18nApi.guestLanguageDefault(params).then((response) => {
                    let defaultLanguageInfo = response.data.data
                    // console.log('First Language');
                    resolve(defaultLanguageInfo)
                }).catch((err) => {
                    // console.log('error Language');
                    resolve(_.find(systemlanguageSet, (lang) => {return lang.code === 'en'}))
                })  
            }
        }        
    })
}

// Set Language
function setLanguage(data){
    // console.log('setLanguage data', data)
    return new Promise((resolve, reject) => {
        // console.log('setLanguage',data);
        if (data.staticFileUrl) {
            axios({
                method: 'GET',
                url: data.staticFileUrl
            }).then((response) => {
                i18n.locale = data.code
                i18n.setLocaleMessage(data.code, response.data)
                localStorage.setItem('languageInfo', JSON.stringify(data))

                // 날짜 유형 변경(set date format)
                Moment.locale(data.code)

                // HTML 언어 설정(set html language attr)
                const html = document.documentElement
                html.setAttribute('lang', data.code)
                
                // 언어에 따른 화면 모드 변경(Set screen mode change according to language)
                if (data.rtl) {
                    store.commit('SET_LANGUAGE_MODE', 'rtl')
                }else {
                    store.commit('SET_LANGUAGE_MODE', 'ltr')
                }
                
                resolve(data)
            })
        }else {
            axios({
                method: 'GET',
                url:  'https://clpintergrateuploadcontents.s3-ap-northeast-1.amazonaws.com/_clpfront/attachment/5/en_0/5/en_00019.json'
            }).then((response) => {
                i18n.locale = data.code
                i18n.setLocaleMessage(data.code, response.data)
                localStorage.setItem('languageInfo', JSON.stringify(data))

                // 날짜 유형 변경(set date format)
                Moment.locale(data.code)

                // HTML 언어 설정(set html language attr)
                const html = document.documentElement
                html.setAttribute('lang', data.code)
                
                // 언어에 따른 화면 모드 변경(Set screen mode change according to language)
                if (data.rtl) {
                    store.commit('SET_LANGUAGE_MODE', 'rtl')
                }else {
                    store.commit('SET_LANGUAGE_MODE', 'ltr')
                }
                
                resolve(data)
            })
           
        }
    })
    
}

// Call external function for language setting
export function setUserLanguage(lang) {
    // console.log('i18Setuplang',lang)
    return new Promise((resolve, reject) => {
        let brandCode = localStorage.getItem('brandCode')
        let params = {
            brandCode: brandCode
        }
        // 언어가 수동으로 변경되거나, 현재 언어 메시지가 없거나, localStorage에 languageInfo가 없는 경우 실행
        if (!Object.keys(i18n.getLocaleMessage(i18n.locale)).length || lang || !localStorage.getItem('languageInfo')) {
            i18nApi.guestLanguagePack(params)
            .then((response) => {  
                return getDefaultLanguage(response.data.data, lang)
            })
            .then((response) => {
                let defaultLanguage = response
                return setLanguage(defaultLanguage)
            })
            .then(() => {
                // console.log(i18n.locale, i18n.getLocaleMessage(i18n.locale))
                resolve()
            })
        }else {
            resolve()
        }
    })
}
